export default __webpack_public_path__ + "locales/sk/InviteDialog.json?hash=4484f8e50a5efa7c6e80ba2e8bd9ae3c";